module.exports = __webpack_public_path__ + "static/media/list_maker.d83911ee.svg";